import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BidiModule } from '@angular/cdk/bidi';
import { CommonModule } from '@angular/common';

import { HeaderModule } from './header/header.module';
import { MainModule } from './main/main.module';
import { AsideModule } from './aside/aside.module';
import { FooterModule } from './footer/footer.module';

import { LayoutComponent } from './layout.component';

const LAYOUT_MODULES = [HeaderModule, MainModule, AsideModule, FooterModule];

@NgModule({
  imports: [BidiModule, CommonModule, LAYOUT_MODULES],
  declarations: [LayoutComponent],
  exports: [LayoutComponent]
})
export class LayoutModule {
  constructor(@Optional() @SkipSelf() parentModule: LayoutModule) {
    if (parentModule) {
      throw new Error('LayoutModule is already loaded, import it only once.');
    }
  }
}
